import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // Updated import statement
import Layout from './Components/Layout/Layout';
import Home from './Components/Home/Home';
import Health from './Components/Health/Health';
import NotFound from './Components/NotFound/NotFound';

function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<Layout/>}>
          <Route index element={<Home/>} />
          <Route path="health" element={<Health/>} />
          <Route path="*" element={<NotFound/>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
